import { UserSimple } from './user-simple';

export class GroupUser extends UserSimple {
  Id: number;
  GroupId: number;
  UserId: number;
  IsAdmin: boolean;
}
